interface MaintenanceInfo {
  isMaintenance: boolean;
  message?: string;
  startTime?: string;
  endTime?: string;
}

interface MaintenanceState {
  maintenanceInfo: MaintenanceInfo;
}

const state: MaintenanceState = {
  maintenanceInfo: {
    isMaintenance: false,
    message: "",
    startTime: "",
    endTime: "",
  },
};

const mutations = {
  SET_MAINTENANCE_INFO(state: MaintenanceState, info: MaintenanceInfo) {
    state.maintenanceInfo = {
      ...state.maintenanceInfo,
      ...info,
    };
  },
  CLEAR_MAINTENANCE_INFO(state: MaintenanceState) {
    state.maintenanceInfo = {
      isMaintenance: false,
      message: "",
      startTime: "",
      endTime: "",
    };
  },
};

const actions = {
  setMaintenanceInfo({ commit }: any, info: MaintenanceInfo) {
    commit("SET_MAINTENANCE_INFO", info);
  },
  clearMaintenanceInfo({ commit }: any) {
    commit("CLEAR_MAINTENANCE_INFO");
  },
};

const getters = {
  maintenanceInfo: (state: MaintenanceState) => state.maintenanceInfo,
  isMaintenance: (state: MaintenanceState) =>
    state.maintenanceInfo.isMaintenance,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
